import { CollectionConfig } from "@rebasepro/types";

/**
 * Notes — what the team wrote down about a candidate or a company.
 *
 * Employers have had `prospect_activity` since 0040; the people this business
 * places had their questionnaire, their mail, and nowhere to write "called
 * her, available from October". Append-only, like the activity log: a note is
 * a record of what somebody thought at the time, and editing one later is
 * how a record stops being one.
 *
 * `entity_type` + `entity_id` rather than two foreign keys: a note names a
 * row in one of two tables, and the pair is exactly what the covers query.
 * FORCE RLS in the database (drizzle/0054) — a note about a person is as
 * private as their correspondence.
 */
const notesCollection: CollectionConfig = {
    name: "Notas",
    singularName: "Nota",
    slug: "notes",
    table: "notes",
    securityRules: [
        {
            name: "admin_full_access",
            operation: "all",
            roles: ["admin"]
        }
    ],
    properties: {
        id: {
            name: "ID",
            type: "string",
            isId: "uuid"
        },
        entity_type: {
            name: "Sobre",
            type: "string",
            enum: [
                { id: "talent", label: "Candidato", color: "green" },
                { id: "company", label: "Empresa", color: "blue" }
            ],
            validation: { required: true }
        },
        entity_id: {
            name: "ID de la ficha",
            type: "string",
            validation: { required: true },
            admin: { readOnly: true }
        },
        body: {
            name: "Nota",
            type: "string",
            validation: { required: true },
            admin: { multiline: true }
        },
        actor: {
            name: "Quién",
            type: "string",
            description: "El email de quien la escribió. Lo pone el panel.",
            admin: { readOnly: true }
        },
        created_at: {
            name: "Cuándo",
            type: "date",
            autoValue: "on_create"
        }
    },
    admin: {
        group: "Personas",
        icon: "StickyNote",
        sort: ["created_at", "desc"],
        // Read and written from the covers of the records they are about.
        hideFromNavigation: true
    }
};

export default notesCollection;
